import React from 'react'
import { Divider as MuiDivider, DividerProps as MuiDividerProps } from '@mui/material'

interface DividerProps extends MuiDividerProps {
  /**
   * Set the color of the divider
   */
  color?: string
}

export const Divider = (props: DividerProps) => {
  const { color, ...rest } = props

  return <MuiDivider {...rest} style={{ ...rest.style, ...(color && { borderColor: color }) }} />
}
